import React, { useEffect, useState } from 'react';
import { X as CloseIcon } from 'lucide-react';
type PolicyType = 'privacy' | 'terms' | 'warranty';
interface PolicyPopupProps {
  isOpen: boolean;
  onClose: () => void;
  initialPolicy: PolicyType;
}
const PolicyPopup: React.FC<PolicyPopupProps> = ({
  isOpen,
  onClose,
  initialPolicy
}) => {
  const [activePolicy, setActivePolicy] = useState<PolicyType>(initialPolicy);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleTabClick = (policy: PolicyType) => {
    setActivePolicy(policy);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-332">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col" data-id="element-333">
        <div className="flex items-center justify-between border-b border-gray-200 p-4" data-id="element-334">
          <h2 className="text-xl font-bold text-[#1e293b]" data-id="element-335">
            {activePolicy === 'privacy' && 'Política de Privacidad'}
            {activePolicy === 'terms' && 'Términos de Uso'}
            {activePolicy === 'warranty' && 'Garantía de Producto'}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Cerrar" data-id="element-336">
            <CloseIcon size={24} data-id="element-337" />
          </button>
        </div>
        <div className="flex border-b border-gray-200" data-id="element-338">
          <button className={`px-4 py-3 font-medium text-sm transition-colors ${activePolicy === 'privacy' ? 'border-b-2 border-[#8b5cf6] text-[#8b5cf6]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => handleTabClick('privacy')} data-id="element-339">
            Política de Privacidad
          </button>
          <button className={`px-4 py-3 font-medium text-sm transition-colors ${activePolicy === 'terms' ? 'border-b-2 border-[#8b5cf6] text-[#8b5cf6]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => handleTabClick('terms')} data-id="element-340">
            Términos de Uso
          </button>
          <button className={`px-4 py-3 font-medium text-sm transition-colors ${activePolicy === 'warranty' ? 'border-b-2 border-[#8b5cf6] text-[#8b5cf6]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => handleTabClick('warranty')} data-id="element-341">
            Garantía
          </button>
        </div>
        <div className="p-6 overflow-y-auto" data-id="element-342">
          {activePolicy === 'privacy' && <div className="space-y-4 text-[#4a5568]" data-id="element-343">
              <h3 className="text-lg font-semibold text-[#1e293b]" data-id="element-344">
                Política de Privacidad
              </h3>
              <p data-id="element-345">
                En Corona de Alivio, respetamos su privacidad y nos
                comprometemos a proteger sus datos personales. Esta política de
                privacidad le informará sobre cómo cuidamos sus datos personales
                cuando visita nuestro sitio web y le informará sobre sus
                derechos de privacidad.
              </p>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-346">
                Información que recopilamos
              </h4>
              <p data-id="element-347">
                Podemos recopilar, utilizar, almacenar y transferir diferentes
                tipos de datos personales sobre usted, que hemos agrupado de la
                siguiente manera:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-348">
                <li data-id="element-349">Datos de identidad: nombre, apellido</li>
                <li data-id="element-350">
                  Datos de contacto: dirección de correo electrónico, número de
                  teléfono, dirección
                </li>
                <li data-id="element-351">
                  Datos de transacción: detalles sobre pagos y productos
                  adquiridos
                </li>
                <li data-id="element-352">
                  Datos técnicos: dirección IP, datos de inicio de sesión, tipo
                  de navegador
                </li>
              </ul>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-353">
                Cómo utilizamos sus datos
              </h4>
              <p data-id="element-354">
                Utilizamos sus datos personales solo cuando la ley nos lo
                permite. Generalmente, utilizaremos sus datos personales en las
                siguientes circunstancias:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-355">
                <li data-id="element-356">Para procesar y entregar su pedido</li>
                <li data-id="element-357">Para gestionar nuestra relación con usted</li>
                <li data-id="element-358">Para mejorar nuestros productos y servicios</li>
                <li data-id="element-359">Para cumplir con obligaciones legales o reglamentarias</li>
              </ul>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-360">
                Seguridad de datos
              </h4>
              <p data-id="element-361">
                Hemos implementado medidas de seguridad apropiadas para evitar
                que sus datos personales se pierdan, utilicen o accedan de forma
                no autorizada.
              </p>
            </div>}
          {activePolicy === 'terms' && <div className="space-y-4 text-[#4a5568]" data-id="element-362">
              <h3 className="text-lg font-semibold text-[#1e293b]" data-id="element-363">
                Términos de Uso
              </h3>
              <p data-id="element-364">
                Al acceder y utilizar este sitio web, usted acepta estos
                términos y condiciones en su totalidad. Si no está de acuerdo
                con estos términos y condiciones o cualquier parte de estos
                términos y condiciones, no debe utilizar este sitio web.
              </p>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-365">
                Licencia para usar el sitio web
              </h4>
              <p data-id="element-366">
                A menos que se indique lo contrario, Corona de Alivio y/o sus
                licenciantes poseen los derechos de propiedad intelectual del
                material en este sitio web. Sujeto a la licencia a continuación,
                todos estos derechos de propiedad intelectual están reservados.
              </p>
              <p data-id="element-367">
                Puede ver, descargar y imprimir páginas desde el sitio web para
                su uso personal, sujeto a las restricciones establecidas a
                continuación y en otros lugares de estos términos y condiciones.
              </p>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-368">
                Restricciones de uso
              </h4>
              <p data-id="element-369">No debe:</p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-370">
                <li data-id="element-371">Republicar material de este sitio web</li>
                <li data-id="element-372">
                  Vender, alquilar o sublicenciar material de este sitio web
                </li>
                <li data-id="element-373">
                  Reproducir, duplicar, copiar o explotar material de este sitio
                  web con fines comerciales
                </li>
                <li data-id="element-374">Redistribuir contenido de este sitio web</li>
              </ul>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-375">
                Limitación de responsabilidad
              </h4>
              <p data-id="element-376">
                La información en este sitio web se proporciona "tal cual", sin
                garantía de integridad, exactitud, puntualidad o de los
                resultados obtenidos del uso de esta información, y sin garantía
                de ningún tipo, expresa o implícita.
              </p>
              <p data-id="element-377">
                En ningún caso Corona de Alivio será responsable ante usted o
                cualquier persona por cualquier decisión o acción tomada
                basándose en la información de este sitio web.
              </p>
            </div>}
          {activePolicy === 'warranty' && <div className="space-y-4 text-[#4a5568]" data-id="element-378">
              <h3 className="text-lg font-semibold text-[#1e293b]" data-id="element-379">
                Garantía de Producto
              </h3>
              <div className="bg-[#f0f9ff] p-4 rounded-lg border border-[#bae6fd] mb-4" data-id="element-380">
                <p className="font-medium text-[#0369a1]" data-id="element-381">
                  Ofrecemos una garantía de satisfacción de 30 días en todos
                  nuestros productos.
                </p>
              </div>
              <p data-id="element-382">
                En Corona de Alivio, confiamos en la calidad de nuestros
                productos y queremos que usted esté completamente satisfecho con
                su compra. Por eso, ofrecemos una garantía de devolución de
                dinero de 30 días en todos nuestros productos.
              </p>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-383">
                Cobertura de la garantía
              </h4>
              <p data-id="element-384">Nuestra garantía cubre:</p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-385">
                <li data-id="element-386">Defectos de fabricación</li>
                <li data-id="element-387">Daños durante el envío</li>
                <li data-id="element-388">Funcionamiento incorrecto del producto</li>
                <li data-id="element-389">Insatisfacción general con el producto</li>
              </ul>
              <h4 className="text-md font-semibold mt-4 text-[#1e293b]" data-id="element-390">
                Proceso de devolución
              </h4>
              <p data-id="element-391">
                Si no está satisfecho con su compra por cualquier motivo,
                simplemente:
              </p>
              <ol className="list-decimal pl-5 space-y-1" data-id="element-392">
                <li data-id="element-393">
                  Contáctenos dentro de los 30 días posteriores a la recepción
                  del producto
                </li>
                <li data-id="element-394">Explique brevemente el motivo de su devolución</li>
                <li data-id="element-395">
                  Devuelva el producto en su empaque original si es posible
                </li>
                <li data-id="element-396">Una vez recibido, procesaremos su reembolso completo</li>
              </ol>
              <p className="mt-4 font-medium" data-id="element-397">
                No hacemos preguntas. No hay letras pequeñas. Su satisfacción es
                nuestra prioridad.
              </p>
              <div className="bg-[#f0fdf4] p-4 rounded-lg border border-[#86efac] mt-4" data-id="element-398">
                <p className="text-[#166534]" data-id="element-399">
                  <span className="font-semibold" data-id="element-400">Nota importante:</span> La
                  garantía de 30 días comienza desde el día en que recibe el
                  producto, no desde la fecha de compra.
                </p>
              </div>
            </div>}
        </div>
        <div className="border-t border-gray-200 p-4 flex justify-end" data-id="element-401">
          <button onClick={onClose} className="bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-4 py-2 rounded-md transition-colors" data-id="element-402">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
};
export default PolicyPopup;